import React from 'react'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { BorderType, BorderStyleEnum } from 'common/types/styleTypes'
import { getMobileOrDesktop } from 'src/shared/utils/get-mobile-or-desktop'
import { RangeElement } from 'src/editor/shared/ui-lib/range-element'

interface BorderTypeControlProps {
  border: Partial<BorderType> | undefined
  mobileBorder?: Partial<BorderType> | undefined
  update: (value: Partial<BorderType>) => void
  mobileUpdate?: ((value: Partial<BorderType>) => void) | undefined
  label?: string
}

export const BorderWidthControl = ({
  border,
  mobileBorder,
  update,
  mobileUpdate,
  label = 'website_styles_settings.border_width.label',
}: BorderTypeControlProps) => {
  const { isMobile } = useDeviceModeContext()

  const resultBorder = getMobileOrDesktop(border, mobileBorder, isMobile)
  const resultUpdate = getMobileOrDesktop(update, mobileUpdate, isMobile)

  return (
    resultBorder?.style &&
    resultBorder?.style !== BorderStyleEnum.none && (
      <RangeElement
        label={label}
        value={resultBorder?.width || 1}
        onChange={value =>
          resultUpdate({
            ...resultBorder,
            width: value,
          })
        }
        max={10}
      />
    )
  )
}
